import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from '../components/navigation';
import { Footer } from '../components/footer';
import { CheckCircle, Phone, ArrowRight } from 'lucide-react';
import { companyInfo } from '../data/mock';

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />

      <div className="min-h-screen flex items-center justify-center px-4 py-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl w-full text-center"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: 0.2, type: 'spring' }}
            className="w-24 h-24 bg-orange-500 rounded-sm flex items-center justify-center mx-auto mb-8 shadow-hard"
          >
            <CheckCircle className="w-12 h-12 text-white" strokeWidth={1.5} />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="font-heading text-5xl md:text-6xl font-bold text-slate-900 mb-6 uppercase tracking-wide"
          >
            Thank You!
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="font-body text-xl text-gray-600 mb-4 leading-relaxed"
          >
            Your quote request has been received. We'll review your project details and get back to you within <strong>24 hours</strong>.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="font-body text-gray-500 mb-10"
          >
            Need a faster response? Call us directly:
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-4 justify-center mb-12"
          >
            <div className="flex items-center justify-center gap-3 px-8 py-4 bg-orange-500 text-white font-bold uppercase tracking-wider rounded-sm shadow-hard">
              <Phone className="w-5 h-5" />
              <span>{companyInfo.phone}</span>
            </div>
            <div className="flex items-center justify-center gap-3 px-8 py-4 bg-slate-900 text-white font-bold uppercase tracking-wider rounded-sm shadow-hard">
              <Phone className="w-5 h-5" />
              <span>{companyInfo.phoneSecondary}</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white border-2 border-slate-200 hover:border-orange-500 text-slate-700 hover:text-orange-600 font-bold uppercase tracking-wider rounded-sm transition-all"
            >
              Back to Home
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-bold uppercase tracking-wider rounded-sm shadow-hard transition-all"
            >
              Our Services
              <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default ThankYouPage;
